// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {buildFilterQueryString} from '../../shared/services/build-query';

const LeadAccountCellRenderer = props =>
    props.value ?
        <Link
            to={`/reimbursement-summary/details?query=${props.data.leadAccount}&leadAccount=${props.data.leadAccount}&leadAccountDisplayName=${encodeURIComponent(props.data.leadAccountDisplayName)}&postingDateFrom=${props.colDef.queryParams.postingDateFrom}&postingDateTo=${props.colDef.queryParams.postingDateTo}${buildFilterQueryString(props.colDef.unpaidFilter)}`}
        >
            {props.value}
        </Link> : null;

LeadAccountCellRenderer.displayName = 'LeadAccountCellRenderer';
LeadAccountCellRenderer.propTypes = {
    colDef: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    value: PropTypes.string
};

export default LeadAccountCellRenderer;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/lead-account-cell-renderer.js